<h1 mat-dialog-title>
  <span transloco="IMPORT_DATA_AND_DOCS_JOB_MANAGER"></span>
</h1>
<mat-dialog-content>
  @if (jobIds$ | async; as jobIds) {
    <mat-accordion multi>
      @for (jobId of jobIds; track jobId) {
        @if (selectJob$(jobId) | async; as job) {
          <mat-expansion-panel
            (opened)="onOpenJobPanel(jobId)"
            (closed)="onCloseJobPanel(jobId)"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ job.startTime.toLocaleString() }}
              </mat-panel-title>
              <mat-panel-description>
                {{ getJobStatusMessage(job.status) }}
              </mat-panel-description>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <mat-progress-bar
                mode="determinate"
                [value]="job.status.progress"
              ></mat-progress-bar>
              <p style="margin-top: 12px">
                {{ getJobProgressText(job.status) }}
              </p>
              @if (job.status.erroredRows > 0) {
                <p
                  transloco
                  [translocoParams]="{
                    erroredRowTotal: job.status.erroredRows,
                  }"
                >
                  ERRORED_ROWS_FAILED_TO_IMPORT
                </p>
              }
              @if (jobResults[jobId]; as jobResult) {
                <div style="width: 100%; align-content: center">
                  <h3 transloco="RESULTS"></h3>
                  @if (jobResult.errorMessages.length) {
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>Errors</mat-label>
                      <textarea
                        cdkTextareaAutosize
                        matInput
                        readonly
                        [value]="jobResult.errorMessages.join('\n')"
                      ></textarea>
                    </mat-form-field>
                  }
                  <mat-form-field
                    appearance="outline"
                    class="result-form-field"
                  >
                    <mat-label>Imported rows</mat-label>
                    <input matInput readonly [value]="jobResult.importedRows" />
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    class="result-form-field"
                  >
                    <mat-label>Errored rows</mat-label>
                    <input matInput readonly [value]="jobResult.erroredRows" />
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    class="result-form-field"
                  >
                    <mat-label>Total rows</mat-label>
                    <input matInput readonly [value]="jobResult.totalRows" />
                  </mat-form-field>
                </div>
              }
              <div class="job-action-row">
                <button
                  mat-icon-button
                  [disabled]="getDisableResults(job.status)"
                  [matTooltip]="'RESULTS' | transloco"
                  matTooltipShowDelay="1000"
                  (click)="onClickResult(jobId)"
                >
                  <mat-icon>visibility</mat-icon>
                </button>
                <button
                  mat-icon-button
                  [disabled]="getDisableResults(job.status)"
                  [matTooltip]="'DOWNLOAD' | transloco"
                  matTooltipShowDelay="1000"
                  (click)="onClickDownloadResults(jobId)"
                >
                  <mat-icon>download</mat-icon>
                </button>
                <span class="spacer"></span>
                <button
                  mat-button
                  [disabled]="
                    job.status.cancelled ||
                    job.status.done ||
                    !job.status.started
                  "
                  (click)="onClickCancel(jobId)"
                >
                  <span transloco="CANCEL"></span>
                </button>
                <button
                  mat-button
                  [disabled]="getDisableDelete(job.status)"
                  (click)="onClickDelete(jobId)"
                >
                  <span transloco="DELETE"></span>
                </button>
              </div>
            </ng-template>
          </mat-expansion-panel>
        }
      }
    </mat-accordion>
  } @else {
    <p transloco="NO_IMPORT_JOBS_TO_DISPLAY"></p>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close><span transloco="CLOSE"></span></button>
</mat-dialog-actions>
